export const Arrow = () => (
  <svg
    width='348'
    height='348'
    viewBox='0 0 348 348'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M85.7996 119.589C85.4492 119.195 85.8779 118.517 86.3845 118.663C92.058 120.295 108.192 124.108 114.584 116.875C120.625 110.037 93.1432 153.592 96.5663 145.708C100.316 137.071 89.7521 124.032 85.7996 119.589Z'
      fill='#3BAAB0'
    />
  </svg>
)

export const ArrowDropdown = () => (
  <svg  
    xmlns="http://www.w3.org/2000/svg"  
    width="24"  
    height="24"  
    viewBox="0 0 24 24"  
    fill="none"  
    stroke="currentColor"  
    stroke-width="2"  
    stroke-linecap="round"  
    stroke-linejoin="round">
      <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
      <path d="M6 9l6 6l6 -6" />
    </svg>
)


export const ArrowCircleRight = (
  props: React.SVGAttributes<SVGSVGElement> & { color?: string }
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='36'
    height='36'
    viewBox='0 0 36 36'
    fill='none'
    {...props}
  >
    <mask
      id='mask0_100_7407'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='3'
      y='3'
      width='30'
      height='30'
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M18 5.375C11.0274 5.375 5.375 11.0274 5.375 18C5.375 24.9726 11.0274 30.625 18 30.625C24.9726 30.625 30.625 24.9726 30.625 18C30.625 11.0274 24.9726 5.375 18 5.375ZM3.625 18C3.625 10.0609 10.0609 3.625 18 3.625C25.9391 3.625 32.375 10.0609 32.375 18C32.375 25.9391 25.9391 32.375 18 32.375C10.0609 32.375 3.625 25.9391 3.625 18ZM18.236 12.611C18.5777 12.2693 19.1317 12.2693 19.4735 12.611L24.1727 17.3103C24.185 17.3226 24.1969 17.3351 24.2083 17.3478C24.3873 17.508 24.5 17.7409 24.5 18C24.5 18.2603 24.3863 18.4941 24.2059 18.6544C24.1952 18.6662 24.1841 18.6778 24.1727 18.6892L19.4735 23.3885C19.1317 23.7302 18.5777 23.7302 18.236 23.3885C17.8943 23.0467 17.8943 22.4927 18.236 22.151L21.512 18.875H12.375C11.8918 18.875 11.5 18.4832 11.5 18C11.5 17.5168 11.8918 17.125 12.375 17.125H21.5126L18.236 13.8485C17.8943 13.5067 17.8943 12.9527 18.236 12.611Z'
        fill='black'
      />
    </mask>
    <g mask='url(#mask0_100_7407)'>
      <rect width='36' height='36' fill={props?.color || '#218B8F'} />
    </g>
  </svg>
)

export const ArrowCircle = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 30 31'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0.1753 3.77618C-0.175113 3.38229 0.253621 2.70432 0.760275 2.85005C6.4337 4.48197 22.5678 8.2954 28.9592 1.06162C35.0006 -5.77599 7.51897 37.7793 10.942 29.8953C14.6919 21.2584 4.1278 8.21905 0.1753 3.77618Z'
      fill='#fff'
    />
  </svg>
)
